import { PILLARS } from "@/data/content";
import { Reveal, SectionHead } from "@/components/site/Reveal";

export const About = () => (
  <section id="programme" data-testid="about-section" className="section">
    <SectionHead
      eyebrow="The Programme"
      testid="about-title"
      title={<>Nine days.<br /><span className="accent-text">One standard.</span></>}
      intro="Elite Performance Lab is a nine-day intensive football development programme designed to improve players' technical ability, tactical awareness, decision-making, confidence and overall football performance — led by experienced UEFA A licensed coaches with professional football development backgrounds."
    />
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
      <Reveal className="lg:col-span-5 relative">
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem]">
          <img src="/images/programme.jpg" alt="Young players in a training session" loading="lazy" className="w-full h-full object-cover grayscale-[35%] hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-white/10" />
        </div>
        <p className="absolute -bottom-6 -right-2 lg:-right-8 bg-[var(--accent)] text-[#070a11] font-display font-extrabold tracking-tight text-4xl px-6 py-4 rounded-2xl">9 Days</p>
      </Reveal>
      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.08} className="rounded-3xl bg-white/[0.03] border border-white/10 p-8 md:p-10 group hover:border-[var(--accent)]/40 hover:bg-white/[0.05] transition-colors">
            <div data-testid={`pillar-${p.n}`}>
              <p className="font-mono-epl text-sm accent-text">{p.n}</p>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight group-hover:text-[var(--accent)] transition-colors">{p.t}</h3>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">{p.d}</p>
            </div>
          </Reveal>
        ))}
        <div className="sm:col-span-2 rounded-2xl bg-[var(--accent)]/[0.05] border border-[var(--accent)]/15 px-8 py-5">
          <p className="text-xs text-slate-400 leading-relaxed" data-testid="no-guarantee-note">
            Elite Performance Lab is a development programme. We do not promise trials, contracts, selections or professional outcomes — we focus on making every player better.
          </p>
        </div>
      </div>
    </div>
  </section>
);
